export const selectValueMixins = {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  inject: {
    params:{
      default: () => ({
        showStatFields: true,
        // group:''
      })
    }
  },
  computed: {
    selectValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      }
    },
    typeSelectOptions(){
      if(Object.keys(this.params).includes('getGroupId')){
        return [{ label: '题目', value: '3' }]
      }else{
        return [
          { label: '基础信息', value: '0' },
          { label: '调查员属性', value: '1' },
          { label: '题目', value: '3' },
        ]
      }
    }
  }
}

export const randomMixins = {
  methods: {
    // 生成随机数
    getRandomKey() {
      return `${Date.now()}${Math.floor(Math.random() * 9999)}`
    }
  }
}
